import { Injectable } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, map, tap } from 'rxjs';
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { TimeSpan } from 'src/app/shared/helpers/time-span';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { ITimeEntry } from 'src/app/time-tracking/models/time-entry';
import { IAssignment, ICreateAssignmentRequest, IUpdateAssignmentRequest } from '../models/assignment';
import { AssignmentService } from '../services/assignment.service';
import { IAssignmentService } from '../models/assignment-service';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class AssignmentStorageService {

  constructor(
    private assignmentService : AssignmentService,
    private appnotificationService: AppNotificationService
  ) { }

  private _assignment$ = new BehaviorSubject<IAssignment>(null);
  public assignment$ = this._assignment$.asObservable();

  public searchRequest: IBaseSearchRequest = {
    pageNumber: 0,
    pageSize: 25
  }

  getAssignment(id: string){
  this.assignmentService.getAssignment(id)
    .pipe(
      untilDestroyed(this),
      map(response => {

        response.totalTimeObj = TimeSpan.parse(response.totalTime)

        response.timeEntries = response.timeEntries.map((timeEntry: ITimeEntry) => {
          timeEntry.date = new Date(timeEntry.date);
          return timeEntry;
        });
        response.timeEntries.sort((a, b) => {
          if (b.date.getTime() > a.date.getTime()) return 1;
          if (b.date.getTime() < a.date.getTime()) return -1;

          if (TimeSpan.parse(b.start).getTotalSeconds() > TimeSpan.parse(a.start).getTotalSeconds()) return -1;
          if (TimeSpan.parse(b.start).getTotalSeconds() < TimeSpan.parse(a.start).getTotalSeconds()) return 1;

        });

        // convert string to TimeSpan
        response.assignmentServices.map((assigmentService: IAssignmentService) => {
          if(assigmentService.time){
            assigmentService.timeObj = TimeSpan.parse(assigmentService.time)
          }
          return assigmentService
        })

        return response;
      })
    )
    .subscribe(response => {
      this._assignment$.next(this.calculateTotalOfTimeEntries(response))
    })
  }

  createAssignment(request: ICreateAssignmentRequest){
    this.assignmentService.createAssignment(request)
    .pipe(untilDestroyed(this))
    .subscribe(response => {
      this.getAssignment(response);
      this.appnotificationService.notification$.next({message: translate('assignment.createSuccess'), style: 'success'})
    })
  }

  updateAssignment(request: IUpdateAssignmentRequest){
    this.assignmentService.updateAssignment(request)
    .pipe(untilDestroyed(this))
    .subscribe(response => {
      this.getAssignment(response);
      this.appnotificationService.notification$.next({message: translate('assignment.updateSuccess'), style: 'success'})
    })
  }

  deleteAssignment(id: string) {
    return this.assignmentService.deleteAssignment(id).pipe(
      tap(() => {
        this._assignment$.next(null);
        this.appnotificationService.notification$.next({
          message: translate('assignment.deleteSuccess'),
          style: 'success'
        });
      })
    );
  }  

  calculateTotalOfTimeEntries(assignment: IAssignment){
    assignment.assignmentServices.map(service => {
      // find all Time Entries with this assignmentService Id
      var timeEntries = assignment.timeEntries.filter(timeEntry => timeEntry.assignmentServiceId == service.id)
      // calculate sum of all Time Entries
      if(timeEntries){
        var totalTimeEntries = new TimeSpan();

        timeEntries.forEach(timeEntry => {
          if(timeEntry.duration){
            totalTimeEntries = totalTimeEntries.add(TimeSpan.parse(timeEntry.duration))
          }
        })

        // Add this sum to the assignemtService
        service.totalTimeEntries = totalTimeEntries;
      }
    })

    assignment.timeEntriesTotal = assignment.assignmentServices.reduce(
      (total, service)=> total.add(service.totalTimeEntries),
      new TimeSpan());


    assignment.defaultTimeTotal = assignment.assignmentServices.reduce(
      (total, service)=> total.add(service.time ? TimeSpan.parse(service.time) : TimeSpan.fromSeconds(0)),
      new TimeSpan());


    return assignment;
  }

  resetStore(){
    this._assignment$.next(null);
  }
}
